// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Spinner_spinnerContainer__9kofH","spinner":"Spinner_spinner__ki4vs","rotate":"Spinner_rotate__3J7Px"};